const Services = [
  {
    id: 1,
    image: '',
    name: 'Technology',
    quotes: 'Automate Your Business',
  },
  {
    id: 2,
    image: '',
    name: 'Financials',
    quotes: 'Fullfill Your Need',
  },
  {
    id: 3,
    image: '',
    name: 'Management',
    quotes: 'Make Your Business Alive',
  },
  {
    id: 4,
    image: '',
    name: 'Business',
    quotes: 'Collaborative Growth is Life',
  },
  {
    id: 5,
    image: '',
    name: 'Due Diligence',
    quotes: 'Become Insightfully Informed',
  },
  {
    id: 6,
    image: '',
    name: 'Entrepreneure Club',
    quotes: 'Meet, Collaborate and Grow',
  },
];

export default Services;
